import HeaderBackButton from 'components/molecules/HeaderBackButton';
import { SpinnerLoader } from 'components/molecules/Loaders';
import { useConfig } from 'context/app-config';
import React from 'react';
import { Container } from 'react-bootstrap';

import styles from './styles.module.scss';

const FineryPricingScreen: React.FC = () => {
  const config = useConfig();
  const [showLoader, setShowLoader] = React.useState(true);
  return (
    <>
      {config?.showBackButton && (
        <div className="ml-2">
          <HeaderBackButton />
        </div>
      )}
      <Container className={styles.containerIframe}>
        {showLoader && <SpinnerLoader />}
        <iframe
          className={styles.iframe}
          title="The Finery"
          src="https://www.thefinery.com/in-app/finery-pricing-careem "
          onLoad={() => setShowLoader(false)}
        />
      </Container>
    </>
  );
};

export default FineryPricingScreen;
